module.exports = __webpack_public_path__ + "static/edit-file-to-change-active-tab-of-products-by-category-2-00ea840c21553d809f2b4a406c1e59b8.png";